import React, { useState, useContext } from "react";
import { Redirect } from "react-router-dom";
import { Row, Col, Alert } from "reactstrap";

import Intro from "../../organisms/intro";
import { NodeBar } from "../../organisms/node-bar/NodeBar";
import { nodeTypes, START } from "../../../utils/nodeTypes";
import { NodeItem } from "../../molecules/node-item";
import MainContainer from "../main-container";
import TabFlows from "../tab-flows";
import ExplorerBar from "../../organisms/explorer-bar";
import GuestHeader from "../../organisms/guest-header";
import { mrTypes } from "../../../utils/mrTypes";
import { Container } from "../container";
import API from "../../../api/API";
import {
  NEW_WORKFLOW,
  GET_WORKFLOW,
  GET_MODEL,
  SAVE_MODEL,
  SAVE_WORKFLOW,
  DEPLOY_MODEL,
  DEPLOY_WORKFLOWS,
} from "../../../api/projects";
import { DISABLE_INTRO } from "../../../api/user";
import { showToast, t, AppContext } from "../../../utils/utils";
import { useApolloClient } from "@apollo/react-hooks";
import firstWorkflow from "../../../assets/images/first_workflow.svg";
import accessDenied from "../../../assets/images/access_denied.svg";

import { GrToJdcModel, GrToJdcWorkflow } from "../../../utils/grToJdcWorkflow";
import { workFlow_type } from "../../../utils/editorUtils";
import GenericModal from "../../organisms/modal";
import GenericForm from "../../organisms/form";
import AlertModal from "../../organisms/alert-modal";
import Loading from "../../atoms/loading";
import { EMPTY_VALIDATION } from "../../../constants";
import { cloneDeep } from "lodash";
import ProjectDeployment from "../../organisms/project-deployment/ index";
import ProjectConfig from "../../organisms/project-config";

const Editor = ({ project }) => {
  //info del usuario desde contexto
  const appContext = useContext(AppContext);
  //hooks
  const [redirect, setRedirect] = useState(null);
  const [extended, setExtended] = useState(true);
  const [tabs, setTabs] = useState([]);
  const [types, setTypes] = useState([]);
  const [activeTab, setActiveTab] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [modalDeployOpen, setModalDeployOpen] = useState(false);
  const [modalConfigOpen, setModalConfigOpen] = useState(false);
  const [unsavedChanges, setUnsavedChanges] = useState(false);
  const [activeWorkflow, setActiveWorkflow] = useState(null);
  const [savingWorkflow, setSavingWorkflow] = useState(false);

  //para saber si estoy abriendo un workflow
  const [openingWorkflow, setOpeningWorkflow] = useState(false);

  //para saber si corresponde abrir el intro
  const [intro, setIntro] = useState(
    appContext && appContext.userInfo && appContext.userInfo.firstTime
  );

  const [formData, setFormData] = useState(null);
  const [isValidForm, setIsValidForm] = useState(false);
  const client = useApolloClient();

  const [workflows, setWorkFlows] = useState(project.workflows);

  const [workflowsToDeploy, setWorkflowsToDeploy] = useState([]);
  const [deployStatus, setDeployStatus] = useState({
    deploying: false,
    status: "",
    ready: false,
    error: false,
  });

  const [model, setModel] = useState({
    slug: "Models",
    id: "MR",
    jdc: {
      id: project.relationalModel.id,
      mode: "MR",
      models: project.relationalModel.models
        ? JSON.parse(project.relationalModel.models)
        : null,
      connections: project.relationalModel.associations
        ? JSON.parse(project.relationalModel.associations)
        : null,
    },
  });

  const [projectRoles, setProjectRoles] = useState(project.roles);

  const updateModel = (jdc) => {
    const tmp = cloneDeep(model);
    tmp.jdc.models = jdc.models;
    tmp.jdc.connections = jdc.connections;
    setModel(tmp);
  };
  //callbacks
  const onToggle = (expanded) => {
    setExtended(expanded);
  };
  const modelsOnProject = () => {
    let models;
    //console.log(model)
    if (model.jdc.models == null) {
      models = model.jdc;
      models.models = [];
    } else {
      models = model.jdc;
    }
    return models;
  };
  const onToggleModal = () => {
    setModalOpen(!modalOpen);
  };
  const onSelect = async (selected) => {
    if (selected === "new") {
      onToggleModal();
    } else if (selected === "config") {
      setModalConfigOpen(true);
    } else {
      const flow =
        selected !== "MR" ? workflows.find((o) => o.id === selected) : model;
      if (flow) {
        const tmp = tabs;
        if (!tmp.find((o) => o.id === selected)) {
          //si no esta abierto, lo traigo de BD
          //se abre el modal de carga de workflows
          setOpeningWorkflow(true);
          if (selected !== "MR") {
            const res = await getWorkflow(selected);
            if (res) {
              const json = res.content ? JSON.parse(res.content) : null;
              tmp.push({
                ...flow,
                jdc: {
                  ...json,
                  id: flow.id,
                  slug: flow.slug,
                  mode: "workflow",
                },
              });
              setTabs(tmp);
            }
          } else {
            const res = await getModel();
            if (res) {
              tmp.push({
                slug: "Models",
                id: "MR",
                jdc: {
                  id: res.id,
                  mode: "MR",
                  models: res.models ? JSON.parse(res.models) : null,
                  connections: res.associations
                    ? JSON.parse(res.associations)
                    : null,
                },
              });
              setTabs(tmp);
            }
          }
          //se cierra el modal de carga de workflows
          setOpeningWorkflow(false);
          onToggleTab(selected);
        }
      }
    }
  };
  const onToggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      const tmp = tabs.find((o) => o.id === tab);
      //TODO: verificar que el cambio de tab actualiza el estado de workflowActivo
      if (tmp) setTypes(tmp.id === "MR" ? mrTypes : nodeTypes);
    }
  };
  const onCloseTab = (tabID) => {
    if (tabs.length > 1) {
      const tmp = tabs.filter((o) => o.id !== tabID);
      setTabs(tmp);
      //se valida el caso en el que por algún motivo (error/inconsistencia)
      //despues de cerrar este tab, no hayan otros (segun tabID) abiertos
      if (tmp[0]) {
        onToggleTab(tmp[0].id);
      } else {
        setActiveTab("");
      }
    }
  };

  const getWorkflow = async (id) => {
    try {
      const res = await API.query(client, GET_WORKFLOW, {
        id: id,
      });
      if (res && res.data && res.data.getWorkflow) {
        return res.data.getWorkflow;
      } else {
        showToast(t("errorRecuperarWorkflow"), "error");
      }
    } catch ({ graphQLErrors, networkError }) {
      if (graphQLErrors && graphQLErrors.length > 0) {
        showToast(graphQLErrors[0].message, "error");
      } else if (networkError) {
        showToast(t("errorRecuperarWorkflow"), "error");
      } else {
        showToast(t("errorRecuperarWorkflow"), "error");
        setRedirect("/");
      }
    }
  };

  const getModel = async () => {
    try {
      const res = await API.query(client, GET_MODEL, {
        projectId: project.id,
      });
      if (res && res.data && res.data.getRelationalModel) {
        return res.data.getRelationalModel;
      } else {
        showToast(t("errorRecuperarModelo"), "error");
      }
    } catch ({ graphQLErrors, networkError }) {
      if (graphQLErrors && graphQLErrors.length > 0) {
        showToast(graphQLErrors[0].message, "error");
      } else if (networkError) {
        showToast(t("errorRecuperarModelo"), "error");
      } else {
        showToast(t("errorRecuperarModelo"), "error");
        setRedirect("/");
      }
    }
  };

  const createWorkflow = async () => {
    if (isValidForm && formData) {
      const tmp = workflows;
      try {
        const res = await API.mutation(client, NEW_WORKFLOW, {
          projectId: project.id,
          input: { slug: formData.nombre, description: formData.descripcion },
        });

        if (res && res.data && res.data.createWorkflow) {
          showToast(t("nuevoFlujoCreadoExitosamente"));
          const { id, slug } = res.data.createWorkflow;
          tmp.push({
            slug: slug,
            id: id,
            jdc: {
              slug: slug,
              id: id,
              mode: "workflow",
            },
            unauthorized_roles: null,
          });
          setWorkFlows(tmp);
        } else {
          showToast(t("errorCrearFlujo"), "error");
        }
      } catch ({ graphQLErrors, networkError }) {
        if (graphQLErrors && graphQLErrors.length > 0) {
          showToast(graphQLErrors[0].message, "error");
        } else if (networkError) {
          showToast(t("errorCrearFlujo"), "error");
        } else {
          showToast(t("errorCrearFlujo"), "error");
          setRedirect("/");
        }
      }
      onToggleModal();
    } else {
      showToast(t("corrijaErroresAntesCrearWorkflow"), "error");
    }
  };

  const onSaveWorkflow = async (show = true) => {
    if (activeWorkflow && (unsavedChanges || show)) {
      setSavingWorkflow(true);
      const { id, slug, state } = activeWorkflow;
      if (state.mode === "MR") {
        const jdc = GrToJdcModel(state);
        updateModel(jdc);
        try {
          const res = await API.mutation(client, SAVE_MODEL, {
            id: project.relationalModel.id,
            relationalModel: {
              models: JSON.stringify(jdc.models),
              associations: JSON.stringify(jdc.connections),
            },
          });
          if (res && res.data && res.data.saveRelationalModel) {
            if (show) showToast(t("modeloActualizado"));
            setUnsavedChanges(false);
          } else {
            showToast(t("errorActualizarCambiosModelo"), "error");
          }
        } catch ({ graphQLErrors, networkError }) {
          if (graphQLErrors && graphQLErrors.length > 0) {
            showToast(graphQLErrors[0].message, "error");
          } else if (networkError) {
            showToast(t("errorActualizarCambiosModelo"), "error");
          } else {
            showToast(t("errorActualizarCambiosModelo"), "error");
          }
        }
      } else {
        const newContent = GrToJdcWorkflow(slug, id, state);
        newContent.type = workFlow_type(state.nodes);
        try {
          const res = await API.mutation(client, SAVE_WORKFLOW, {
            id: id,
            newContent: JSON.stringify(newContent),
          });
          if (res && res.data && res.data.saveWorkflow) {
            if (show) showToast(t("workflowActualizado"));
            setUnsavedChanges(false);
          } else {
            showToast(t("errorActualizarCambiosWorkflow"), "error");
          }
        } catch ({ graphQLErrors, networkError }) {
          if (graphQLErrors && graphQLErrors.length > 0) {
            showToast(graphQLErrors[0].message, "error");
          } else if (networkError) {
            showToast(t("errorActualizarCambiosWorkflow"), "error");
          } else {
            showToast(t("errorActualizarCambiosWorkflow"), "error");
          }
        }
      }
      setSavingWorkflow(false);
    }
  };

  const deployProject = async () => {
    console.log("se despliegan los workflows con id", workflowsToDeploy);
    try {
      setDeployStatus({
        deploying: true,
        status: t("desplegandoModelo"),
        ready: false,
        error: false,
      });
      await API.mutation(client, DEPLOY_MODEL, {
        id: project.relationalModel.id,
      });
      if (workflowsToDeploy.length > 0) {
        setDeployStatus({
          deploying: true,
          status: t("desplegandoWorkflows"),
          ready: false,
          error: false,
        });
        await API.mutation(client, DEPLOY_WORKFLOWS, {
          ids: workflowsToDeploy,
        });
      }
      setDeployStatus({
        deploying: false,
        status: t("despliegueCompletado"),
        ready: true,
        error: false,
      });
    } catch (error) {
      setDeployStatus({
        deploying: false,
        status: t("despliegueConError"),
        ready: false,
        error: true,
      });
    }
  };

  const disableIntro = async () => {
    setIntro(false);
    if (appContext && appContext.userInfo && appContext.userInfo.firstTime) {
      //en este caso ademas de esconder el intro, se informa al backend
      //que el usuario ya hizo su primera visita
      try {
        await API.mutation(client, DISABLE_INTRO, {});
        appContext.setUserInfo({ ...appContext.userInfo, firstTime: false });
      } catch (error) {}
    }
  };

  if (redirect) return <Redirect to={redirect} />;
  return (
    <>
      <div className="d-block d-md-none">
        <GuestHeader />
        <Container style={{ minHeight: "80vh" }}>
          <Row>
            <Col xs="10" className="mx-auto mt-5">
              <Alert color="info" className="text-center">
                <h1 className="font-size-14">{t("atencion")}</h1>
                <p>{t("porElMomentoEditorDisponibleEnEscritorio")}</p>
              </Alert>
            </Col>
          </Row>
          <Row>
            <Col
              className="mx-auto text-center"
              xs="10"
              md="6"
              style={{ marginTop: "5vh" }}
            >
              <img src={accessDenied} alt="Deshabilitado" width="80%" />
            </Col>
          </Row>
        </Container>
      </div>
      <div className="d-none d-md-flex">
        <MainContainer>
          <ExplorerBar
            callBack={{
              onSelect: onSelect,
              onToggle: onToggle,
            }}
            project={project}
            workflows={workflows}
            model={model}
            expanded={extended}
          />
          <Container expanded={extended}>
            {Array.isArray(tabs) && tabs.length > 0 ? (
              <TabFlows
                closeTab={onCloseTab}
                tabs={tabs}
                activeTab={activeTab}
                getModels={modelsOnProject}
                toggle={onToggleTab}
                onWorkflowChange={(id, slug, state) => {
                  setUnsavedChanges(true);
                  setActiveWorkflow({ id: id, slug: slug, state: state });
                  //se deshabilita el guardado automatico para modelos
                  //TODO: se debe guardar automatico solo en cambios relevantes
                  // if (state && state.mode && state.mode === "MR") {
                  //   onSaveWorkflow(false);
                  // }
                }}
                onSaveWorkflow={onSaveWorkflow}
              />
            ) : (
              <>
                <Row>
                  <Col
                    className="mx-auto"
                    xs="11"
                    md="6"
                    lg="5"
                    style={{ marginTop: "3vh" }}
                  >
                    <p className="mt-3 mb-2 text-center font-size-12">
                      {t("introEditorAvisoComenzar")}{" "}
                      <a
                        className="btn btn-outline-primary"
                        href="#tour"
                        onClick={() => setIntro(true)}
                      >
                        {t("introEditorBotonComenzar")}
                      </a>
                    </p>
                  </Col>
                </Row>
                <Row>
                  <Col
                    className="mx-auto"
                    xs="12"
                    md="6"
                    style={{ marginTop: "5vh" }}
                  >
                    <img
                      src={firstWorkflow}
                      alt="new workflow"
                      width="80%"
                      className="cursor-pointer"
                      onClick={() => onSelect("new")}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs="12">
                    <h1 className="mt-4 text-center">
                      {Array.isArray(workflows) && workflows.length > 0
                        ? t("abreFlujoOCreaUnoNuevo")
                        : t("creaTuPrimerWorkflow")}
                    </h1>
                  </Col>
                </Row>
              </>
            )}
            <NodeBar
              project={project.slug}
              activeWorkflow={Array.isArray(types) && types.length > 0}
              unsavedChanges={unsavedChanges}
              savingWorkflow={savingWorkflow}
              onSaveWorkflow={onSaveWorkflow}
              openDeployModal={() => setModalDeployOpen(true)}
              intro={intro}
            >
              {types
                .filter((type) => type.type !== START)
                .map((o, key) => (
                  <NodeItem key={key} {...o} />
                ))}
            </NodeBar>
          </Container>
        </MainContainer>
        {/* <ModalForm
        title={"Crear nuevo WorkFlow"}
        open={modalOpen}
        toggle={onToggleModal}
        submit={state => {
          createWorkflow(state);
        }}
        form={[
          {
            name: "Nombre",
            type: "text",
            required: true
          },

          {
            name: "Descripcion",
            type: "textarea",
            required: true
          }
        ]}
      /> */}
        <GenericModal
          isOpen={modalOpen}
          title={t("nuevoWorkflow")}
          primaryButtonText={t("crear")}
          primaryButton
          primaryAction={() => createWorkflow()}
          closeButtonText={t("cerrar")}
          closeAction={() => onToggleModal()}
        >
          <GenericForm
            id="new-workflow"
            setFormData={(data) => setFormData(data)}
            setValidForm={(result) => setIsValidForm(result)}
            fields={[
              {
                name: "nombre",
                type: "text",
                label: t("nombre"),
                placeholder: t("nuevoWorkflowNombrePlaceholder"),
                validations: [EMPTY_VALIDATION],
              },
              {
                name: "descripcion",
                type: "textarea",
                label: t("descripcion"),
                placeholder: t("nuevoWorkflowDescripcionPlaceholder"),
                validations: [],
              },
            ]}
          />
        </GenericModal>
        <GenericModal
          isOpen={modalDeployOpen}
          size="lg"
          title={t("desplegarProyecto")}
          primaryButtonText={t("desplegar")}
          primaryButton={!deployStatus.ready && !deployStatus.error}
          primaryAction={deployProject}
          closeButtonText={t("cerrar")}
          closeAction={() => {
            setDeployStatus({
              deploying: false,
              status: "",
              ready: false,
              error: false,
            });
            setModalDeployOpen(false);
          }}
          primaryActionInProcess={deployStatus.deploying}
        >
          {modalDeployOpen && (
            <ProjectDeployment
              project={project}
              workflowsToDeploy={workflowsToDeploy}
              setWorkflowsToDeploy={setWorkflowsToDeploy}
              deployStatus={deployStatus}
            />
          )}
        </GenericModal>
        {/* Modal para la configuración del proyecto */}
        <GenericModal
          isOpen={modalConfigOpen}
          size="xl"
          title={t("configuracionProyecto")}
          primaryButton={false}
          closeButtonText={t("cerrar")}
          closeAction={() => setModalConfigOpen(false)}
        >
          <ProjectConfig
            projectId={project.id}
            projectRoles={projectRoles}
            setProjectRoles={(updatedRoles) => setProjectRoles(updatedRoles)}
            workflows={workflows}
            setWorkflows={(updatedWorkflows) => setWorkFlows(updatedWorkflows)}
          />
        </GenericModal>
        {/*
      Si estoy abriendo un workflow se levanta un modal a modo de feedback
       */}
        <AlertModal isOpen={openingWorkflow} title={t("avisoAbriendoWorkflow")}>
          <Row>
            <Col xs="auto" className="mx-auto">
              <Loading width={300} height={300} />
            </Col>
          </Row>
        </AlertModal>
        {intro && <Intro show={intro} exit={disableIntro} />}
      </div>
    </>
  );
};

// Title.defaultProps = {
//   className: '',
//   children: '',
// }

export default Editor;
